import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-toggle',
  templateUrl: './toggle.component.html',
  imports: [TranslateDirective],
})
export class ToggleComponent {
  @Input() isToggled: boolean;
  @Input() label: string;
  @Input() translateParams;
  @Output() toggleChanged = new EventEmitter<boolean>();
}
